import React, { createContext, useContext, ReactNode } from 'react';
import { UserTypeFilter } from '@/hooks/usePaginatedMediaData';
import { useGlobalUserTypeFilter } from '@/hooks/useGlobalUserTypeFilter';

interface AdminFilterContextType {
  userTypeFilter: UserTypeFilter;
  setUserTypeFilter: (filter: UserTypeFilter) => void;
  resetFilters: () => void;
}

const AdminFilterContext = createContext<AdminFilterContextType | undefined>(undefined);

export const AdminFilterProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { userTypeFilter, setUserTypeFilter, resetFilter } = useGlobalUserTypeFilter();

  return (
    <AdminFilterContext.Provider
      value={{
        userTypeFilter,
        setUserTypeFilter,
        resetFilters: resetFilter
      }}
    >
      {children}
    </AdminFilterContext.Provider>
  );
};

export const useAdminFilter = () => {
  const context = useContext(AdminFilterContext);
  if (context === undefined) {
    throw new Error('useAdminFilter must be used within AdminFilterProvider');
  }
  return context;
};
